// Who can open the Engage pages (Inbox, Campaigns) and which channels each one lists.
//
// Email is an admin feature; WhatsApp follows `Organization.whatsapp.enabled` and is open to
// members (the API scopes them to their own contacts' threads and their own campaigns). Read-only
// users get neither: the inbox and campaign APIs are Member+, so they would only meet 403s. Kept
// as pure functions so the router guard, the nav model and the pages cannot disagree.

export type EngageChannel = 'whatsapp' | 'email'

export interface EngageContext {
  isAdmin: boolean
  whatsappEnabled: boolean
  /** `role === 'readonly'`: no channel at all. */
  isReadonly?: boolean | undefined
}

/** WhatsApp first (the board's order), then email. */
function channelsFor(ctx: EngageContext): EngageChannel[] {
  const channels: EngageChannel[] = []
  if (ctx.isReadonly) return channels
  if (ctx.whatsappEnabled) channels.push('whatsapp')
  if (ctx.isAdmin) channels.push('email')
  return channels
}

/** Channels the Inbox lists threads for. */
export function inboxChannels(ctx: EngageContext): EngageChannel[] {
  return channelsFor(ctx)
}

/** Channels the Campaigns list lists campaigns for (and offers under "New campaign"). */
export function campaignChannels(ctx: EngageContext): EngageChannel[] {
  return channelsFor(ctx)
}

/** `/inbox` and `/campaigns` are reachable when at least one channel is available. */
export function canOpenEngage(ctx: EngageContext): boolean {
  return channelsFor(ctx).length > 0
}
